webpackJsonp([5],{

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(729),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'termo-de-uso',
  data: function data() {
    return {
      dialogTermoUso: false
    };
  }
});

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'termo-legal',
  data: function data() {
    return {
      dialogTermoLegal: false
    };
  }
});

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tabelaClasses___ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tabelaClasses____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tabelaClasses___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermoLegal__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermoLegal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TermoLegal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermoDeUso__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermoDeUso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TermoDeUso__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cadastro',
  components: {
    TabelaClasses: __WEBPACK_IMPORTED_MODULE_0__components_tabelaClasses____default.a,
    TermoLegal: __WEBPACK_IMPORTED_MODULE_1__TermoLegal___default.a,
    TermoUso: __WEBPACK_IMPORTED_MODULE_2__TermoDeUso___default.a
  },
  data: function data() {
    var _this = this;

    return {
      cadastroCompleto: false,
      loading: false,
      termosDeUso: false,
      formValido: false,
      nomeFantasia: '',
      nomeFantasiaRegras: [function (v) {
        return !!v || 'Nome em branco';
      }, function (v) {
        return v.length < 61 || 'Nome fantasia inválido';
      }, function (v) {
        return v.length > 2 || 'Precisa conter no minimo 3 caracteres';
      }],
      documento: '',
      documentoRegras: [function (v) {
        return !!v || 'Documento em branco';
      }, function (v) {
        return v.length < 19 || 'Documento inválido';
      }, function (v) {
        return _this.validaDocumento(v) || 'Documento inválido';
      }],
      nomeCompleto: '',
      nomeCompletoRegras: [function (v) {
        return !!v || 'Nome em branco';
      }],
      telefone: '',
      telefoneRegras: [function (v) {
        return !/[^0-9()-\W]{1,15}/.test(v) || 'Telefone inválido';
      }, function (v) {
        return !!v || 'Telefone em branco';
      }, function (v) {
        return v.length < 16 || 'Telefone inválido';
      }, function (v) {
        return v.length > 13 || 'Telefone inválido';
      }],
      email: '',
      emailRegras: [function (v) {
        return !!v || 'E-mail em branco';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail inválido'
        );
      }],
      usuario: '',
      usuarioRegras: [function (v) {
        return !!v || 'Usuario em branco';
      }, function (v) {
        return (/^\S*$/.test(v) || 'Espaço não permitido'
        );
      }, function (v) {
        return v.length < 20 || 'Usuario inválido';
      }],
      senha: '',
      senhaRegras: [function (v) {
        return !!v || 'Preencha uma senha';
      }, function (v) {
        return v.length > 5 || 'A senha deve ter no mínimo 6 caracteres';
      }],
      senhaComparacao: '',
      senhaComparacaoRegras: [function (v) {
        return !!v || 'Preencha uma senha';
      }, function (v) {
        return _this.senha === v || 'As senhas não são iguais';
      }]
    };
  },

  computed: {
    mascaraTelefone: {
      get: function get() {
        return this.telefone;
      },
      set: function set(newValue) {
        var _this2 = this;

        if (/[^0-9()-\W]{1,15}/.test(newValue) || newValue.length > 15) {
          this.resetMascara();
          return;
        }
        newValue = newValue.replace(/\D/g, '');
        newValue = newValue.replace(/^(\d{2})(\d)/g, '($1) $2');
        newValue = newValue.replace(/(\d)(\d{4})$/, '$1-$2');
        setTimeout(function () {
          _this2.telefone = newValue;
        }, 1);
      }
    },
    mascaraDocumento: {
      get: function get() {
        return this.documento;
      },
      set: function set(newValue) {
        var _this3 = this;

        if (/[^0-9./-\W]{1,18}/.test(newValue) || newValue.length > 18) {
          this.resetMascaraDocumento();
          return;
        }
        newValue = newValue.replace(/\D/g, '');
        if (newValue.length <= 11) {
          newValue = newValue.replace(/(\d{3})(\d)/, '$1.$2');
          newValue = newValue.replace(/(\d{3})(\d)/, '$1.$2');
          newValue = newValue.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        } else {
          newValue = newValue.replace(/^(\d{2})(\d)/, '$1.$2');
          newValue = newValue.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
          newValue = newValue.replace(/\.(\d{3})(\d)/, '.$1/$2');
          newValue = newValue.replace(/(\d{4})(\d)/, '$1-$2');
        }
        setTimeout(function () {
          _this3.documento = newValue;
        }, 1);
      }
    }
  },
  methods: {
    toLogin: function toLogin() {
      this.$router.push('/Login/');
      return;
    },

    validaDocumento: function validaDocumento(numero) {
      numero = numero.replace(/\D/g, '');
      if (numero.length === 11) {
        var cpf = numero;
        var Soma = 0;
        var Resto = 0;
        if (cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
          return false;
        }
        for (var i = 1; i <= 9; i++) {
          Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        Resto = Soma * 10 % 11;

        if (Resto === 10 || Resto === 11) {
          Resto = 0;
        }
        if (Resto !== parseInt(cpf.substring(9, 10))) {
          return false;
        }
        Soma = 0;
        for (var _i = 1; _i <= 10; _i++) {
          Soma = Soma + parseInt(cpf.substring(_i - 1, _i)) * (12 - _i);
        }
        Resto = Soma * 10 % 11;
        if (Resto === 10 || Resto === 11) {
          Resto = 0;
        }
        if (Resto !== parseInt(cpf.substring(10, 11))) {
          return false;
        }
        return true;
      } else if (numero.length === 14) {
        var cnpj = numero;
        if (cnpj === '00000000000000' || cnpj === '11111111111111' || cnpj === '22222222222222' || cnpj === '33333333333333' || cnpj === '44444444444444' || cnpj === '55555555555555' || cnpj === '66666666666666' || cnpj === '77777777777777' || cnpj === '88888888888888' || cnpj === '99999999999999') {
          return false;
        }
        var tamanho = cnpj.length - 2;
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var _i2 = tamanho; _i2 >= 1; _i2--) {
          soma += numeros.charAt(tamanho - _i2) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(0))) {
          return false;
        }
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (var _i3 = tamanho; _i3 >= 1; _i3--) {
          soma += numeros.charAt(tamanho - _i3) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(1))) {
          return false;
        }
      } else {
        return false;
      }
      return true;
    },
    resetMascara: function resetMascara() {
      var _this4 = this;

      var original = this.telefone;
      this.telefone = this.telefone + ' ';
      setTimeout(function () {
        _this4.telefone = original;
      }, 1);
    },
    resetMascaraDocumento: function resetMascaraDocumento() {
      var _this5 = this;

      var original = this.documento;
      this.documento = this.documento + ' ';
      setTimeout(function () {
        _this5.documento = original;
      }, 1);
    },
    cadastrar: function cadastrar(event) {
      var _this6 = this;

      this.$refs.form.validate();
      if (!this.termosDeUso) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Aceite os termos de uso'
        });
        return;
      }
      if (this.$store.getters.arrayCategorias.length === 0) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Selecione uma categoria do seu negócio'
        });
        return;
      }
      if (!this.formValido) {
        // this.$store.commit('toastr', {
        //   color: 'error',
        //   texto: 'Campos inválidos'
        // })
        return;
      }

      this.loading = true;

      // ajuste para o back end
      var telefone = this.telefone.replace(/\D/g, '');
      var ddd = telefone.substring(0, 2);
      var numero = telefone.substring(2, telefone.length);
      this.$http.post('PreCadastro/Salvar', {
        Fantasia: this.nomeFantasia,
        Pessoa: this.documento.length === 18 ? 'J' : 'F',
        Documento: this.documento.replace(/\D/g, ''),
        Email: this.email,
        Ddd: ddd,
        Telefone: numero,
        NomeCompleto: this.nomeCompleto,
        NomeUsuario: this.usuario,
        Senha: this.senha,
        Categorias: this.$store.getters.arrayCategorias
      }).then(function (response) {
        var data = response.data.resultado;
        if (data.code === 200) {
          // store TOKEN
          _this6.cadastroCompleto = true;
          _this6.$store.commit('toastr', {
            color: 'success',
            texto: 'Informações enviadas'
          });
          _this6.cadastroCompleto = true;
        } else {
          _this6.$store.commit('toastr', {
            color: 'error',
            texto: data.mensagem
          });
        }
        _this6.loading = false;
      }).catch(function () {
        _this6.$store.commit('toastr', {
          color: 'error',
          texto: 'Erro de conecxão'
        });
        _this6.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    classe: Object,
    pesquisa: String
  },
  data: function data() {
    return {
      dialogm1: '',
      dialog: false
    };
  },

  computed: {
    categoriasVisiveis: function categoriasVisiveis() {
      var exp = new RegExp(this.pesquisa.trim(), 'i');
      return this.classe.CategoriasLista.filter(function (categoria) {
        return exp.test(categoria.Nome);
      }).length;
    },
    classeSelecionada: {
      get: function get() {
        var _this = this;

        return this.classe.CategoriasLista.filter(function (categoria) {
          return _this.$store.getters.arrayCategorias.indexOf(categoria.Registro) !== -1;
        }).length !== 0;
      },
      set: function set() {
        return;
      }
    }
  },
  methods: {
    verCategorias: function verCategorias() {
      this.$emit('visualizar', this.classe);
    },
    pesquisado: function pesquisado(value) {
      var exp = new RegExp(this.pesquisa.trim(), 'i');
      return exp.test(value);
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Classe__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Classe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Classe__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabela-classes',
  components: {
    'classe': __WEBPACK_IMPORTED_MODULE_1__Classe___default.a
  },
  // props: {
  //   categorias: Array,
  // },
  data: function data() {
    return {
      pesquisar: '',
      classes: [],
      loading: true,
      dialog: false,
      sugestao: false
    };
  },

  computed: {
    classeSelecionada: {
      get: function get() {
        return this.$store.getters.arrayCategorias;
      },
      set: function set(idCategoria) {
        if (idCategoria.length > 1) {
          var classes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.classes));
          classes = classes.filter(function (elemento) {
            return elemento.categoriasLista.find(function (categoria) {
              return categoria.id === idCategoria[idCategoria.length - 1];
            });
          });
          if (classes[0].registro !== this.filtroClasseSugerida.registro) {
            this.$store.commit('toastr', {
              color: 'info',
              texto: 'Somente é permitido setores relacionados'
            });
            return;
          }
        }
        this.$store.commit('selecionaCategoria', {
          valor: idCategoria
        });
        return;
      }
    },
    fitroClasse: function fitroClasse() {
      if (this.sugestao === true && this.$store.getters.arrayCategorias.length > 0) {
        return [this.filtroClasseSugerida];
      }
      if (this.pesquisar.length > 1) {
        var exp = new RegExp(this.pesquisar.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), 'i');
        var classes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.classes));
        return classes.filter(function (classe) {
          var categorias = classe.categoriasLista.filter(function (categoria) {
            return exp.test(categoria.detail.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
          });
          classe.categoriasLista = categorias;
          return classe.categoriasLista.length !== 0;
        });
      }
      return [];
    },
    filtroClasseSugerida: function filtroClasseSugerida() {
      var _this = this;

      if (this.$store.getters.arrayCategorias.length === 0) {
        return false;
      } else {
        var classes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.classes));
        return classes.filter(function (elemento) {
          return elemento.categoriasLista.find(function (categoria) {
            return categoria.id === _this.$store.getters.arrayCategorias[0];
          });
        })[0];
      }
    },
    chipsSelecionadas: function chipsSelecionadas() {
      var _this2 = this;

      return this.filtroClasseSugerida.categoriasLista.filter(function (categoria) {
        return _this2.$store.getters.arrayCategorias.indexOf(categoria.id) !== -1;
      });
    }
  },
  methods: {
    removeCategoria: function removeCategoria(idCategoria) {
      this.$store.commit('removeCategoria', {
        valor: idCategoria
      });
      if (this.$store.getters.arrayCategorias.length === 0) {
        this.sugestao = false;
      }
    },
    resetarCategorias: function resetarCategorias() {
      this.sugestao = false;
      this.$store.commit('resetarCategorias');
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$http.get('Categoria/GetLista').then(function (response) {
      var data = response.data.resultado;
      _this3.classes = data.categoriasLista;
      _this3.loading = false;
    }).catch(function (error) {
      _this3.$store.commit('toastrAxiosError', error);
      _this3.loading = false;
    });
  }
});

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TermoLegal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".pt-sans{font-family:PT Sans,sans-serif!important}.ajuste label{white-space:normal;height:70px;line-height:20px}.ajuste label:after{content:\"\"}.voltar{position:relative;left:-13px}.voltar i{color:#e51b2e!important}.voltar i:hover{opacity:.8;color:#d62939!important;-webkit-transition:opacity .2s,color .2s;transition:opacity .2s,color .2s}.titulo{display:inline;position:relative;top:7px}.destaque-cadastro{color:#f3fdfe;padding:30px}.destaque-cadastro img{float:left;width:60px}.destaque-cadastro h5{float:left;width:calc(100% - 60px);padding:0 10px;font-weight:700}.destaque-cadastro h6{float:left;width:100%}@media only screen and (max-width:643px){.box{width:100%!important}.ajuste{margin-bottom:50px}.ajuste label>div>div{display:inline}.ajuste label{white-space:normal;height:100px;line-height:20px;max-width:90%!important}.titulo{position:absolute;left:50%;margin-left:-98px;top:inherit}}@media only screen and (min-width:960px){.ajuste-scroll{padding:0 8.333333333333332%}.custom-loader{-webkit-animation:loader 1s infinite;animation:loader 1s infinite;display:-webkit-box;display:-ms-flexbox;display:flex}}@-webkit-keyframes loader{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loader{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.posCadastro{position:absolute;top:50%;margin-top:-250px;left:50%;margin-left:-250px}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/cadastro/index.vue"],"names":[],"mappings":"AACA,SACE,wCAA6C,CAC9C,AACD,cACE,mBAAoB,AACpB,YAAa,AACb,gBAAkB,CACnB,AACD,oBACE,UAAW,CACZ,AACD,QACE,kBAAmB,AACnB,UAAY,CACb,AACD,UACE,uBAAyB,CAC1B,AACD,gBACE,WAAa,AACb,wBAAyB,AACzB,yCAA2C,AAC3C,gCAAmC,CACpC,AACD,QACE,eAAgB,AAChB,kBAAmB,AACnB,OAAS,CACV,AACD,mBACE,cAAe,AACf,YAAc,CACf,AACD,uBACE,WAAY,AACZ,UAAY,CACb,AACD,sBACE,WAAY,AACZ,wBAAyB,AACzB,eAAgB,AAChB,eAAkB,CACnB,AACD,sBACE,WAAY,AACZ,UAAY,CACb,AACD,yCACA,KACI,oBAAsB,CACzB,AACD,QACM,kBAAoB,CACzB,AACD,sBACM,cAAgB,CACrB,AACD,cACM,mBAAoB,AACpB,aAAc,AACd,iBAAkB,AAClB,uBAAyB,CAC9B,AACD,QACI,kBAAmB,AACnB,SAAU,AACV,kBAAmB,AACnB,WAAa,CAChB,CACA,AACD,yCACA,eACI,4BAA8B,CACjC,AACD,eACE,qCAAsC,AAC9B,6BAA8B,AACtC,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,CACA,AACD,0BACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,kBACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,aACE,kBAAmB,AACnB,QAAS,AACT,kBAAmB,AACnB,SAAU,AACV,kBAAoB,CACrB","file":"index.vue","sourcesContent":["\n.pt-sans{\n  font-family: 'PT Sans', sans-serif!important;\n}\n.ajuste label{\n  white-space: normal;\n  height: 70px;\n  line-height: 20px;\n}\n.ajuste label:after{\n  content: ''\n}\n.voltar{\n  position: relative;\n  left: -13px;\n}\n.voltar i{\n  color: #e51b2e!important;\n}\n.voltar i:hover{\n  opacity: 0.8;\n  color: #d62939!important;\n  -webkit-transition: opacity .2s, color .2s;\n  transition: opacity .2s, color .2s;\n}\n.titulo{\n  display: inline;\n  position: relative;\n  top: 7px;\n}\n.destaque-cadastro{\n  color: #f3fdfe;\n  padding: 30px;\n}\n.destaque-cadastro img{\n  float: left;\n  width: 60px;\n}\n.destaque-cadastro h5{\n  float: left;\n  width: calc(100% - 60px);\n  padding: 0 10px;\n  font-weight: bold;\n}\n.destaque-cadastro h6{\n  float: left;\n  width: 100%;\n}\n@media only screen and (max-width: 643px){\n.box{\n    width: 100%!important;\n}\n.ajuste {\n      margin-bottom: 50px;\n}\n.ajuste label>div>div {\n      display: inline;\n}\n.ajuste label {\n      white-space: normal;\n      height: 100px;\n      line-height: 20px;\n      max-width: 90%!important;\n}\n.titulo{\n    position: absolute;\n    left: 50%;\n    margin-left: -98px;\n    top: inherit;\n}\n}\n@media only screen and (min-width: 960px){\n.ajuste-scroll{\n    padding: 0 8.333333333333332%;\n}\n.custom-loader {\n  -webkit-animation: loader 1s infinite;\n          animation: loader 1s infinite;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n}\n@-webkit-keyframes loader {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.posCadastro{\n  position: absolute;\n  top: 50%;\n  margin-top: -250px;\n  left: 50%;\n  margin-left: -250px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".checkbox[data-v-77ba2a7f]{float:left;width:81%!important}.box[data-v-77ba2a7f]{background:#eee;height:70px;padding-left:5px;border-radius:1px;border:1px solid #dcdcdc}.classNumber[data-v-77ba2a7f]{float:left;background-color:#6699cd;width:30px;height:30px;padding:5px;border-radius:20px;color:#fff;margin-top:18px}.fade-enter-active[data-v-77ba2a7f],.fade-leave-active[data-v-77ba2a7f]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-77ba2a7f],.fade-leave-to[data-v-77ba2a7f]{opacity:0}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/tabelaClasses/Classe.vue"],"names":[],"mappings":"AACA,2BACI,WAAY,AACZ,mBAAqB,CACxB,AACD,sBACE,gBAAoB,AACpB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,8BACE,WAAY,AACZ,yBAA0B,AAC1B,WAAY,AACZ,YAAa,AACb,YAAa,AACb,mBAAoB,AACpB,WAAY,AACZ,eAAiB,CAClB,AACD,wEACE,+BAAgC,AAChC,sBAAuB,CACxB,AACD,6DACE,SAAU,CACX","file":"Classe.vue","sourcesContent":["\n.checkbox[data-v-77ba2a7f]{\n    float: left;\n    width: 81%!important;\n}\n.box[data-v-77ba2a7f]{\n  background: #eeeeee;\n  height: 70px;\n  padding-left: 5px;\n  border-radius: 1px;\n  border: #dcdcdc 1px solid;\n}\n.classNumber[data-v-77ba2a7f]{\n  float: left;\n  background-color: #6699cd;\n  width: 30px;\n  height: 30px;\n  padding: 5px;\n  border-radius: 20px;\n  color: #fff;\n  margin-top: 18px;\n}\n.fade-enter-active[data-v-77ba2a7f], .fade-leave-active[data-v-77ba2a7f] {\n  -webkit-transition: opacity .5s;\n  transition: opacity .5s\n}\n.fade-enter[data-v-77ba2a7f], .fade-leave-to[data-v-77ba2a7f] /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TermoDeUso.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".espacamento{font-size:16px}.tabelaBox{border:1px solid #d9d9d9;padding:20px!important;border-radius:8px!important}.tabelaBox h5{color:#e51b2e;margin-bottom:0}.grow-box label{height:63px;line-height:23px;text-overflow:inherit;white-space:normal}.grow-box-2{height:100px}.grow-box-2 label{height:100px;line-height:20px;text-overflow:inherit;white-space:normal;margin-top:5px}.chips-selecionados{border:1px solid #d7d7d7;background-color:#f4f4f4}.font-red{color:#e51b2e}@media only screen and (max-width:643px){.cadastro-footer{width:100%;position:fixed;bottom:0;left:0;color:#fff;background-color:#ea1d24;text-align:center;padding:10px}.cadastro-footer a{color:#fff!important;font-weight:700}.cadastro-footer span{display:none}}.box{border:1px solid #d9d9d9;border-radius:8px;padding:8px}.box .checkbox{padding-top:5px}.box label{color:#3c3737!important;padding-left:5px;max-width:83%}.box .input-group__input{margin-bottom:12px}.tooltip__content.menuable__content__active{margin-top:10px}.box .input-group__details{display:none}.box .classe{border-top:1px solid #d9d9d9;text-align:left;padding-left:10px}.input-search{border:1px solid #d9d9d9;border-radius:15px;padding:8px;position:relative}.desaparece{display:none}.input-search input{position:absolute;outline:none;top:0;left:0;right:0;bottom:0;width:100%;padding-left:37px;font-size:22px;color:#5a5a5a}.disabled{background-color:#e0e0e0}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/tabelaClasses/index.vue"],"names":[],"mappings":"AACA,aACE,cAAgB,CACjB,AACD,WACE,yBAA0B,AAC1B,uBAAwB,AACxB,2BAA6B,CAC9B,AACD,cACE,cAAe,AACf,eAAiB,CAClB,AACD,gBACE,YAAa,AACb,iBAAkB,AAClB,sBAAuB,AACvB,kBAAoB,CACrB,AACD,YACE,YAAc,CACf,AACD,kBACE,aAAc,AACd,iBAAkB,AAClB,sBAAuB,AACvB,mBAAoB,AACpB,cAAgB,CACjB,AACD,oBACE,yBAA0B,AAC1B,wBAA0B,CAC3B,AACD,UACE,aAAe,CAChB,AACD,yCACA,iBACI,WAAY,AACZ,eAAgB,AAChB,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,yBAA0B,AAC1B,kBAAmB,AACnB,YAAc,CACjB,AACD,mBACI,qBAAsB,AACtB,eAAkB,CACrB,AACD,sBACI,YAAc,CACjB,CACA,AACD,KACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAa,CACd,AACD,eACE,eAAiB,CAClB,AACD,WACE,wBAAyB,AACzB,iBAAkB,AAClB,aAAe,CAChB,AACD,yBACE,kBAAoB,CACrB,AACD,4CACE,eAAiB,CAClB,AACD,2BACE,YAAc,CACf,AACD,aACE,6BAA8B,AAC9B,gBAAiB,AACjB,iBAAmB,CACpB,AACD,cACE,yBAA0B,AAC1B,mBAAoB,AACpB,YAAa,AACb,iBAAmB,CACpB,AACD,YACE,YAAc,CACf,AACD,oBACE,kBAAmB,AACnB,aAAc,AACd,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,WAAY,AACZ,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAChB,AACD,UACE,wBAAyB,CAC1B","file":"index.vue","sourcesContent":["\n.espacamento{\n  font-size: 16px;\n}\n.tabelaBox{\n  border: 1px solid #d9d9d9;\n  padding: 20px!important;\n  border-radius: 8px!important;\n}\n.tabelaBox h5{\n  color: #e51b2e;\n  margin-bottom: 0;\n}\n.grow-box label{\n  height: 63px;\n  line-height: 23px;\n  text-overflow: inherit;\n  white-space: normal;\n}\n.grow-box-2{\n  height: 100px;\n}\n.grow-box-2 label{\n  height: 100px;\n  line-height: 20px;\n  text-overflow: inherit;\n  white-space: normal;\n  margin-top: 5px;\n}\n.chips-selecionados{\n  border: 1px solid #d7d7d7;\n  background-color: #f4f4f4;\n}\n.font-red{\n  color: #e51b2e;\n}\n@media only screen and (max-width: 643px){\n.cadastro-footer{\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    color: #fff;\n    background-color: #ea1d24;\n    text-align: center;\n    padding: 10px;\n}\n.cadastro-footer a{\n    color: #fff!important;\n    font-weight: bold;\n}\n.cadastro-footer span{\n    display: none;\n}\n}\n.box{\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  padding: 8px;\n}\n.box .checkbox{\n  padding-top: 5px;\n}\n.box label{\n  color: #3c3737!important;\n  padding-left: 5px;\n  max-width: 83%;\n}\n.box .input-group__input{\n  margin-bottom: 12px;\n}\n.tooltip__content.menuable__content__active{\n  margin-top: 10px;\n}\n.box .input-group__details{\n  display: none;\n}\n.box .classe{\n  border-top: 1px solid #d9d9d9;\n  text-align: left;\n  padding-left: 10px;\n}\n.input-search {\n  border: 1px solid #d9d9d9;\n  border-radius: 15px;\n  padding: 8px;\n  position: relative;\n}\n.desaparece{\n  display: none;\n}\n.input-search input{\n  position: absolute;\n  outline: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  padding-left: 37px;\n  font-size: 22px;\n  color: #5a5a5a;\n}\n.disabled{\n  background-color: #e0e0e0\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(601);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("983b4aec", content, true, {});

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(602);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("ab7b491a", content, true, {});

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("cfefff1e", content, true, {});

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(634);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("512115fa", content, true, {});

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(639);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("2d5a1ac5", content, true, {});

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNXG14zYAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDkvMTgvMTf07gcOAAAFG0lEQVRogd2aXWxURRTHf1tA6JCOSoIhMRKIPogGkURTpbUErAWVIE+NhkmKGn1QNDz5YPRJffJFE+qTUTGDmtRITJQWjJIWtTw0YDR+YBQlJsZEFB1gii3t+nDmuttNu3fn9m5Z/Cc3m/bec87893zMnjO3UCwWqTeM0muBPUCP9e5Yve011dtAwFJgdfisO+aK1LmKz7pivlH6BmAVJYLzctRfBMaAW8Pf9xqlrwIuAwo52pkIn5PAt4XtzS1HgWuB5nBzPEdjIMTmhWsiXHkSAlgQ9I8CP84HtgK3A73AF8BLwWhehgvINziJREMTQjQPFMO1C7gZeBwYLhSLRYzSzcCXwAHr3c6cDM4ZjNK7gU3ATda70SSPWhAXqou2stlBIetvgbmrfnOK/yWp+Rd7AZUwSl+JhNJkxa0mYNx6dzpNR0ORMkrvAJ5GynMRqZxFStvMhFH6SevdJ9X0NBQp4DtgCNmcJxFCfwAdlDbw64FLh5T17ghwpPx/RukbgW2AQ8hOTCM6BQ1dKIzStwGfA+eBHuA0QqwqGspT5TBKtwP7EQ91AQsJ+1AaGtJTRul1wEeABzZZ734FllEqHFXRcKRCyB1EQu1O693X4VZSOFLRUKSM0q1AP1LxNpQRAgm/xcCiND0NQ8oo3YZ4yAN3We+OVzxyEvgY+CpNV26Fwii9AGhD4n7Iepdaestkkxw6A3RZ776vfMZ6d9IofR/SM1VFLp4ySrcA7wKHkI3xrdDO1CLbinjoL2BjRchNgfXOW+/qXyiM0pcDHyDN5i7gKaAbeC+NWCA0wPQ5lBmzImWUXoIkdgfwoPXuZevdi0gHuhkhtngG2XbEQ+eYPocyIzMpo7QG3kdGAY9Y795I7lnvXgGeQIj1GaUXVsi2ITk0ygw5NBtkIhVyaB/QDjxsvXu18hnr3W5gJ3A3ZaEYQu4ApX3om4xrnxHRpIzSVyA5tBGZuL4207PWu14kFO8B9hmlH0M8lGsOVSKKVMih/UgOPWS9ezNNJoTiDmQw0gucQDyUWw5VomZSIeSSHHrUevd6rbLWuz3IbLEN6LDe/RC70BjUtPmWEUpyaMaQmwnWuxOIl+qOVE8Zpa8GPgQ2kJJDjYJawm8dcAc15lAjoJbw6wdWWu9+rvNackMqKevdWeDsHKwlNyThlwzaL2X8xyEh1YTM2sYu1opmiTFk/U1QCr8L4VoRfjGMk/8ZUj1QRKa5KyhxoJAcZBulnwOeAX5HmrVqJ4oF4B/gT0CT72mJRyZIS5AWvlpaTCATpqXA89a7Z2FqoXgBadRuQdhXwyhwDbAeOI4MIPPooi8gh2etwCDwC3LCWQ3jwAjyEwwo81QsjNL3A28D7da7zzIpmV5vG/Ap8ID17p0sOmbTJG4GTu0dPZMbIYCg71TQnwmZPGWUXgYcQ0JkF/me6E8g587rgbXWu99iFWTNg1XIxHQb0obkdfCd7DVJkVgFzBmpTuQb3YtUytShfQTGkIrWE+wcilUQHX5G6UXIQPGnvaNnuurxblOhUGB7c8tBYCWw2np3PkY+S6FYDlwHDNbrZa2gdzDYWR4rn4XUFmSfOpxBNgaHg50tsYJZSHUjHexwBtkYDAc73bGCsYOXpcAaYMR6l/c7TFMQ9I8Aa4LdmhHrqU6kdPdHymVFf7DXGSMUS2orcvg1ECmXFQPB3tYYoZgR2SIk9Iasd3/HrS0bgp0hJARTD9sSxHhqDEncvsi1zRZ9wW7NDey/lFWgSzwITB4AAAAASUVORK5CYII="

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-cadastro.7c41c1a.png";

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(728),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77ba2a7f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(774),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialogTermoLegal),
      callback: function($$v) {
        _vm.dialogTermoLegal = $$v
      },
      expression: "dialogTermoLegal"
    }
  }, [_c('div', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Termos legais")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Termos legais")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      Os serviços oferecidos neste site, bem como suas marcas, sistemas,\n      conteúdo são protegidos por direitos de propriedade intelectual."), _c('br'), _vm._v("\n\n      Nosso maior objetivo é oferecer um excelente serviço pela Internet e,\n      por isso, poderemos cancelar o cadastro de usuários que venham a\n      prejudicar, de alguma forma, o bom funcionamento do site. Portanto,\n      fica esclarecido que é expressamente proibida a comercialização,\n      reprodução, modificação ou distribuição, de parte ou totalidade das\n      informações e todo o conteúdo contido neste site, sem prévia\n      autorização."), _c('br'), _vm._v("\n\n      Constitui também infração, qualquer uso do site com propósitos ilegais,\n      propagação de vírus de computador ou envio de falsificação de endereços\n      de máquinas ou de correio eletrônico, na tentativa de ocultar a\n      identidade ou autoria, ou de responsabilizar terceiros."), _c('br'), _vm._v("\n\n      Todo o conteúdo do site, caso seja necessário, poderá ser alterado ou\n      cancelado a qualquer momento sem aviso prévio."), _c('br'), _vm._v("\n\n      Com relação ao uso dos \"links\" apresentados no site, é importante\n      salientar que não nos responsabilizamos pelos conteúdos contidos ou\n      fornecidos por estes sites, nem por eventuais prejuízos ou danos\n      causados pelos mesmos."), _c('br'), _vm._v("\n\n      As informações aqui publicadas são passíveis de alterações a qualquer\n      tempo, sem prévia notificação do usuário. Para efeito legal, prevalece\n      o documento original."), _c('br'), _vm._v("\n\n      Nós não nos responsabilizamos por prejuízos da utilização ou não deste\n      site.\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTermoLegal = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm3": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-color": "#ea1d24"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(696),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "destaque-cadastro"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(695),
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n              Cadastre e veja seu negócio crescer!\n          ")]), _vm._v(" "), _c('h6', [_vm._v("\n            Venda mais para Condomínios! Conheça a ferramenta que coloca sua empresa em contato com quem compra!\n          ")])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "no-bar ajuste-scroll",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md9": ""
    }
  }, [_c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-flex', {
    staticClass: "no-bar posCadastro",
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cadastroCompleto),
      expression: "cadastroCompleto"
    }],
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("\n                  Olá, " + _vm._s(_vm.nomeCompleto) + "\n                ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n                  enviaremos em instantes um e-mail para "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "email-vermelho"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(", para confirmar seu cadastro.\n                ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n                  se não chegou ainda, aguarde um pouquinho.\n                ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n                  Equipe, Condoplaza\n                ")]), _vm._v(" "), _c('div', {}, [_c('v-btn', {
    staticClass: "btn-red",
    attrs: {
      "round": "",
      "large": "",
      "dark": ""
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("\n                    Finalizar\n                  ")])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-flex', {
    staticClass: "no-bar",
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cadastroCompleto),
      expression: "!cadastroCompleto"
    }],
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    staticClass: "voltar",
    attrs: {
      "to": "/Login"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "titulo"
  }, [_vm._v("Cadastre seu negócio")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "name": "form-cadastro",
      "value": "true"
    },
    model: {
      value: (_vm.formValido),
      callback: function($$v) {
        _vm.formValido = $$v
      },
      expression: "formValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do seu negócio",
      "hint": "Nome fantasia",
      "rules": _vm.nomeFantasiaRegras,
      "count": 60,
      "required": ""
    },
    model: {
      value: (_vm.nomeFantasia),
      callback: function($$v) {
        _vm.nomeFantasia = $$v
      },
      expression: "nomeFantasia"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Documento",
      "hint": "CPF/CNPJ",
      "rules": _vm.documentoRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.mascaraDocumento),
      callback: function($$v) {
        _vm.mascaraDocumento = $$v
      },
      expression: "mascaraDocumento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Seu nome completo",
      "rules": _vm.nomeCompletoRegras,
      "required": ""
    },
    model: {
      value: (_vm.nomeCompleto),
      callback: function($$v) {
        _vm.nomeCompleto = $$v
      },
      expression: "nomeCompleto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone do seu Negócio",
      "hint": "DDD + Numero",
      "persistent-hint": "",
      "rules": _vm.telefoneRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.mascaraTelefone),
      callback: function($$v) {
        _vm.mascaraTelefone = $$v
      },
      expression: "mascaraTelefone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail do seu Negócio",
      "rules": _vm.emailRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Usuário",
      "rules": _vm.usuarioRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.usuario),
      callback: function($$v) {
        _vm.usuario = $$v
      },
      expression: "usuario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Senha",
      "type": "password",
      "rules": _vm.senhaRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Confirme a Senha",
      "type": "password",
      "rules": _vm.senhaComparacaoRegras,
      "validate-on-blur": true,
      "required": ""
    },
    model: {
      value: (_vm.senhaComparacao),
      callback: function($$v) {
        _vm.senhaComparacao = $$v
      },
      expression: "senhaComparacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('tabela-classes')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ajuste",
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.termosDeUso),
      callback: function($$v) {
        _vm.termosDeUso = $$v
      },
      expression: "termosDeUso"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('div', [_vm._v("Sou representante legal do negócio e li e aceito os")]), _vm._v(" "), _c('TermoLegal'), _vm._v(" e os "), _c('TermoUso')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-green",
    attrs: {
      "round": "",
      "large": "",
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "dark": ""
    },
    on: {
      "click": _vm.cadastrar
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n                     Cadastrar\n                     "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.categoriasVisiveis > 0),
      expression: "categoriasVisiveis > 0"
    }],
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    },
    on: {
      "click": _vm.verCategorias
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('v-checkbox', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.classe.Nome
    },
    model: {
      value: (_vm.classeSelecionada),
      callback: function($$v) {
        _vm.classeSelecionada = $$v
      },
      expression: "classeSelecionada"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "classNumber",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.categoriasVisiveis))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialogTermoUso),
      callback: function($$v) {
        _vm.dialogTermoUso = $$v
      },
      expression: "dialogTermoUso"
    }
  }, [_c('div', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n       Termos e condições de uso do CondoPlaza\n     ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Termos e condições de uso do CondoPlaza")])]), _vm._v(" "), _c('v-card-text', [_c('p', [_c('b', [_vm._v("1. As Partes")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1.1. ATHOS: ATHOS Informática Ltda., inscrita no CNPJ sob nº 000.182.866/0001-60, com sede social na Rua Tamandaré, 796 – Liberdade - São Paulo – SP responsável pelo serviço “CONDOPLAZA” de intermediação de informações para negócios, através do qual o USUÁRIO identificado e cadastrado poderá enviar e receber propostas de cotações de bens e serviços, bem como informações pertinentes ao seu negócio.")]), _vm._v(" "), _c('li', [_vm._v("1.2. USUÁRIO: pessoa física ou jurídica cadastrada no CONDOPLAZA que para utilizar o serviço aceita integralmente o conteúdo deste documento, e será responsável pelo seu cadastro e pela veracidade das informações que publicar no serviço e será identificado através de um login ( “identificação” ) e senha que poderá ter acesso a solicitar, receber, responder e trocar informações pertinentes a atividade do seu negócio, viabilizando transações comerciais entre outros USUÁRIOS do SISTEMA. ")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("2. Definições")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("2.1. CONDOPLA­ZA: é um serviço criado e mantido pela ATHOS, onde compradores e vendedores podem se conhecer, se informar, trocar informações, negociar e realizar transações comerciais de bens e serviços através da Internet. Em sua essência, CONDOPLAZA é um software que pode estar instalado num servidor INTERNET ou no local do USUÁRIO.")]), _vm._v(" "), _c('li', [_vm._v("2.2. LOGIN : nome de usuário ou identificação.")]), _vm._v(" "), _c('li', [_vm._v("2.3. APLICAÇÃO, PLATAFORMA OU SISTEMA: idem CONDOPLAZA.")]), _vm._v(" "), _c('li', [_vm._v("2.4. USUÁRIO: pessoa física ou jurídica cadastrada, que pode ser considerado “comprador” e/ou “vendedor” conforme sua atuação na transação comercial.")]), _vm._v(" "), _c('li', [_vm._v("2.5. INTERNET: rede mundial de computadores.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("3. Objeto")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("3.1. O objetivo do presente instrumento estabelece as condições e termos para uso do CONDOPLAZA a qual todo usuário que se utilizar desta plataforma aceita desde já as condições aqui expressas.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("4. Acesso ao SISTEMA")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("4.1. O USUÁRIO deverá dispor de equipamentos e instalações necessários para acesso ao CONDOPLAZA, tais como : microcomputador ou similar, linha de comunicação ( telefone, tv a cabo etc ), modem ou similar, software etc. A utilização, manutenção e garantia de funcionamento destes equipamentos é de inteira responsabilidade do USUÁRIO.")]), _vm._v(" "), _c('li', [_vm._v("4.2. Na necessidade do SISTEMA requerer reparo, sofrer correções, atualizações, implementações ou inovações, a paralisação dos serviços se necessária, será comunicada com antecedência, sempre que possível.")]), _vm._v(" "), _c('li', [_vm._v("4.3. A ATHOS ficará isenta de qualquer responsabilidade decorrente de interrupção ou suspensão do SISTEMA, em casos de: a) falha no sistema de telecomunicação; b) falha no fornecimento de energia; c) eventos fortuitos ou de força maior; d) ação de terceiros que venham a inabilitar os equipamentos que mantém o SISTEMA.")]), _vm._v(" "), _c('li', [_vm._v("4.4. É proibido o cadastro de USUÁRIO que  não tenha capacidade civil ( no caso de pessoa física ) ou não seja representante legal ( no caso de pessoa jurídica ), bem como de USUÁRIO que tenha sido suspenso pela ATHOS, temporária ou definitivamente, sem prejuízo da aplicação das sanções legais prevista no Código Civil Brasileiro.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("5. Usuários")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("5.1. Será considerado USUÁRIO “vendedor” aquele que : a) Oferecer no SISTEMA bens ou serviços; b) Responder a uma solicitação de cotação ou compra.")]), _vm._v(" "), _c('li', [_vm._v("5.2. Será considerado USUÁRIO “comprador” aquele que : a) Solicitar uma cotação de preço ou um pedido de compra; b) Responder a uma oferta de bens ou serviços.")]), _vm._v(" "), _c('li', [_vm._v("5.3. A ATHOS poderá, a seu livre critério, recusar dados cadastrais enviados para o SISTEMA.")]), _vm._v(" "), _c('li', [_vm._v("5.4. O USUÁRIO poderá negociar e celebrar transações comerciais em nome de terceiros, desde que tenha devida autorização e poderes para representa-lo.")]), _vm._v(" "), _c('li', [_vm._v("5.5. A ATHOS não se responsabiliza pelas informações e idoneidade dos usuários do SISTEMA.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("6. Usuário “comprador”")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("6.1. A ATHOS não se responsabilizará pela ausência ou insuficiência de ofertas, veracidade ou autenticidade dos preços, condições e qualidade dos bens e serviços ofertados.")]), _vm._v(" "), _c('li', [_vm._v("6.2. O USUÁRIO “comprador” é o único e inteiramente responsável pela aceitação das ofertas do USUÁRIO “vendedor”.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("7. Usuário “vendedor”")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("7.1. Ao USUÁRIO “vendedor” caberá exclusivamente responder às cotações de preço e formular sua oferta relativo ao bem ou serviço solicitado pelo USUÁRIO “comprador”.")]), _vm._v(" "), _c('li', [_vm._v("7.2. O USUÁRIO “vendedor” é o único e inteiramente responsável pela : qualidade, disponibilidade, garantia, entrega e demais condições comerciais informadas em suas ofertas de bens ou serviços.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("8. Sistema de Intermediação de Informações")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("8.1. CONDOPLAZA atua de forma passiva não interferindo nas negociações realizadas entre seus USUÁRIOS.")]), _vm._v(" "), _c('li', [_vm._v("8.2. CONDOPLAZA não atua como representante, agente ou mandatário de nenhum USUÁRIO cadastrado e portanto, não tem poderes para negociar ou concluir contratos em nome ou em favor de nenhum USUÁRIO.")]), _vm._v(" "), _c('li', [_vm._v("8.3. O USUÁRIO “vendedor” contatado pelo USUÁRIO “comprador” através do CONDOPLAZA não poderá em hipótese alguma ser considerado indicado do SISTEMA.")]), _vm._v(" "), _c('li', [_vm._v("8.4. A ATHOS compromete-se a respeitar a privacidade do USUÁRIO e manter o teor confidencial das informações, exceto nos seguintes casos: a) Para identificar e solucionar problemas técnicos e operacionais; b) Para cumprir disposição legal ou ordem de autoridade judicial; c) Para cumprir qualquer procedimento instaurado por qualquer órgão regulador ou fiscalizador competente; d) Para fazer cumprir os termos dos serviços; e) Para responder reclamações de que determinado conteúdo viole direitos de terceiros ou proteger o interesse do CONDOPLAZA.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("9. Compromissos e Obrigações")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("9.1. Utilizando-se do CONDOPLAZA, o USUÁRIO deve estar atento em cumprir todas as legislações, municipais, estaduais e federais aplicáveis, que disponham sobre o uso dos serviços disponibilizados, ofertas, listagens, compra e venda de bens ou serviços.")]), _vm._v(" "), _c('li', [_vm._v("9.2. O acesso ao SISTEMA para solicitar ou responder informações é privativo do USUÁRIO cadastrado. Não é permitido o compartilhamento de senhas entre USUÁRIOS e terceiros.")]), _vm._v(" "), _c('li', [_vm._v("9.3. O USUÁRIO é inteiramente responsável por todas as atividades que ocorram sob seu LOGIN e SENHA, devendo para tanto, zelar pela manutenção em local seguro dos dados privativos de acesso ao sistema, de forma a não praticar nenhum ato ou omissão que possa resultar no seu uso indevido por terceiros. O CONDOPLAZA não será responsável por qualquer perda ou dano decorrente do descumprimento do disposto nesta cláusula.")]), _vm._v(" "), _c('li', [_vm._v("9.4. O USUÁRIO compromete-se a não causar nenhum prejuízo, dano ou destruição total ou parcial ao SISTEMA, bem como a não praticar, em prejuízo de outros, nenhum dos seguintes atos : a) Colocar, transmitir ou disponibilizar qualquer material dentro do SISTEMA que contenha qualquer vírus ou qualquer outro tipo de programação para computador; b) Não interceptar, interferir, expropriar do SISTEMA qualquer informação, registro ou dados, que são protegidos por direitos autorais e pela legislação de propriedade intelectual.")]), _vm._v(" "), _c('li', [_vm._v("9.5. O USUÁRIO autoriza desde já a ATHOS a publicar, enviar, informar e notificar informações de caráter publicitário, sem que isso represente qualquer remuneração a seu favor.")]), _vm._v(" "), _c('li', [_vm._v("9.6. O USUÁRIO compromete-se a: a) Não Invadir a privacidade de outros usuários; b) Não quebrar ou tentar quebrar a segurança do SISTEMA, do computador de outro USUÁRIO, programas ou dados; c) Não divulgar informações fraudulentas; d) Não promover a oferta de bens ou serviços decorrentes de atos ilícitos; e) Não violar regras, regimentos, portarias, leis ou qualquer norma que discipline as atividades exercidas; f) Não divulgar conteúdo obsceno, indecente ou pornográfico; g) Não difamar ou ameaçar terceiros, bem como utilizar meios desleais e contrários aos princípios da livre concorrência; h) Não vincular suas informações, produtos, serviços ou dados que sejam proibidos por este instrumento ou por qualquer lei municipal, estadual ou federal.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("10. Indenizações")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("10.1. A ATHOS não será, em hipótese alguma, responsável por perdas ou danos de qualquer espécie oriundos ou relacionados ao uso ou não do serviço, erro na transmissão de informações, interrupção ou suspensão da disponibilidade de acesso ao serviço, uso indevido de senha do USUÁRIO, incluindo, sem limitação, a perdas ou danos diretos, indiretos, lucros cessantes ou qualquer outra forma de indenização. Com exceção do expressamente previsto neste instrumento, a ATHOS não dá qualquer garantia quanto aos resultados que possam ser obtidos com a utilização do SISTEMA.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("11. Responsabilidades")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("11.1. A ATHOS não tem qualquer obrigação em monitorar e verificar o conteúdo das informações divulgadas no CONDOPLAZA, portanto fica isenta de qualquer responsabilidade relativas a tais conteúdos. A ATHOS não garante que “compradores” e “vendedores” agirão conforme o prometido e acordado.")]), _vm._v(" "), _c('li', [_vm._v("11.2. A ATHOS não se responsabiliza pelo conteúdo das informações ou serviços de terceiros que sejam publicados no CONDOPLAZA, através de anúncio, link ou matéria.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("12. Aceitação")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("12.1. O presente instrumento contém as cláusulas e condições gerais que regerão a relação para uso do CONDOPLAZA  entre a ATHOS e o USUÁRIO, inclusive o licenciamento para uso do SISTEMA")]), _vm._v(" "), _c('li', [_vm._v("12.2. A ATHOS poderá, a qualquer momento, alterar ou reduzir no todo ou em parte, os serviços oferecidos através do SISTEMA, a seu exclusivo critério.")]), _vm._v(" "), _c('li', [_vm._v("12.3. A ATHOS poderá realizar aditamentos ao presente instrumento, a qualquer momento, disponibilizando no SISTEMA o conteúdo do aditamento, cuja data da efetividade será considerada aquela em que o conteúdo se tornou disponível no CONDOPLAZA.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("13. Condições Comerciais")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("13.1. O CONDOPLAZA é disponibilizado na modalidade gratuita ( sem custo para o usuário ) e paga ( com custo para o usuário ) e no caso da modalidade paga, todas as condições comerciais estão descritas na Proposta de Adesão que é parte integrante deste instrumento.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("14. Vigência e Rescisão Contratual")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("14.1. O prazo de vigência e multa rescisória, se aplicável, do presente instrumento é conforme estabelecido na Proposta de Adesão na modalidade paga.")]), _vm._v(" "), _c('li', [_vm._v("14.2. Por ausência de falta grave o presente instrumento poderá ser rescindido por qualquer das partes, sem justificativas, mediante notificação por escrito, observadas as seguintes disposições:")]), _vm._v(" "), _c('li', [_vm._v("14.2.1. Caso a rescisão seja solicitada pelo USUÁRIO, o mesmo não deve estar envolvido em negociação não concluída;")]), _vm._v(" "), _c('li', [_vm._v("14.3. Na caracterização de falta grave, a ATHOS poderá rescindir de imediato o presente instrumento através da simples notificação por escrito.")]), _vm._v(" "), _c('li', [_vm._v("14.4. A licença de uso do SISTEMA será extinta concomitantemente com o cancelamento do usuário no CONDOPLAZA.")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("15. Considerações finais")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("15.1. A ATHOS fará uso das informações confidenciais e privativas dos USUÁRIOS apenas no âmbito das atividades desenvolvidas no SISTEMA.")]), _vm._v(" "), _c('li', [_vm._v("15.2. Em hipótese de conflito entre o USUÁRIO “vendedor” e o USUÁRIO “comprador”, em qualquer momento da negociação ou transação, ou posterior a mesma, a solução e acordos se dará fora do SISTEMA, ficando a ATHOS isenta de qualquer obrigação, reivindicação ou responsabilidade sobre os negócios entre “vendedor” e “comprador”.")]), _vm._v(" "), _c('li', [_vm._v("15.3. Ao menor sinal de irregularidade: operacional, comercial ou legal, poderá levar a ATHOS a notificar e/ou suspender, total ou parcialmente, os serviços prestados ao USUÁRIO. Após a notificação o USUÁRIO deverá providenciar a regularização necessária e satisfatória para restabelecimento do serviço. A suspensão total ou parcial dos serviços, não dará direito a nenhuma indenização ou reparo de qualquer dano ao USUÁRIO e/ou terceiros.")]), _vm._v(" "), _c('li', [_vm._v("15.4. A ATHOS não se responsabiliza pela precisão, pontualidade, comercialização e aplicação a uma finalidade específica de qualquer informação divulgada pelo CONDOPLAZA.")]), _vm._v(" "), _c('li', [_vm._v("15.5. A ATHOS não garante que os resultados obtidos com o uso das informações, conteúdos, produtos e serviços fornecidos, ou publicados no CONDOPLAZA, terão resultado adequado, satisfatório ou que servirão para serem comercializados.")]), _vm._v(" "), _c('li', [_vm._v("15.6. O USUÁRIO autoriza desde já, a ATHOS, a divulgar em caráter não exclusivo, durante a vigência contratual, sem exigência de qualquer forma de pagamento, a sua lista de clientes com a razão social ou nome fantasia dos USUÁRIOS, sem que tal utilização caracterize violação a quaisquer direitos do USUÁRIO.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTermoUso = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "tabelaBox",
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md8": ""
    }
  }, [_c('h5', [_vm._v("\n        Seu negócio\n      ")]), _vm._v(" "), _c('p', [_vm._v("Selecione uma categoria de interesse para fornecer seus produtos e/ou serviços")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": ""
    }
  }, [_c('div', {
    class: _vm.sugestao ? 'input-search disabled' : 'input-search'
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisar),
      expression: "pesquisar"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "Procurar",
      "disabled": _vm.sugestao
    },
    domProps: {
      "value": (_vm.pesquisar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisar = $event.target.value
      }
    }
  })], 1)])], 1), _vm._v(" "), (!(_vm.filtroClasseSugerida === false || _vm.filtroClasseSugerida === [])) ? [_c('div', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "chips-selecionados",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "font-red pa-3 espacamento"
  }, [_vm._v("Categoria"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" escolhida"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.chipsSelecionadas), function(chip) {
    return _c('v-chip', {
      key: chip.id,
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.removeCategoria(chip.id)
        }
      }
    }, [_vm._v(_vm._s(chip.name))])
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-1 pb-2",
    staticStyle: {
      "border-bottom": "1px solid #d7d7d7"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "link",
    on: {
      "click": _vm.resetarCategorias
    }
  }, [_vm._v("\n            Quero pesquisar novamente\n          ")])])], 1), _vm._v(" "), (!_vm.sugestao) ? _c('v-layout', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          Encontramos "), _c('strong', [(_vm.filtroClasseSugerida.categoriasLista.length < 10) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s(_vm.filtroClasseSugerida.categoriasLista.length) + " Categoria"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" semelhante"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sugestao = !_vm.sugestao
      }
    }
  }, [_vm._v("visualizar")])])], 1) : _c('v-layout', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sugestao = !_vm.sugestao
      }
    }
  }, [_vm._v("Voltar a pesquisa")])])], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": "",
      "text-xs-center": "",
      "fluid": ""
    }
  }, [_vm._l((_vm.fitroClasse), function(classe, i) {
    return [_c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('div', [_vm._v(_vm._s(classe.nome))])]), _vm._v(" "), _vm._l((classe.categoriasLista), function(categoria, index) {
      return [_c('transition', {
        key: index,
        attrs: {
          "name": "fade"
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "sm6": "",
          "md4": ""
        }
      }, [_c('div', {
        staticClass: "box"
      }, [(categoria.name.length > 27) ? _c('v-tooltip', {
        attrs: {
          "top": ""
        }
      }, [_c('template', {
        slot: "activator"
      }, [_c('v-checkbox', {
        staticStyle: {
          "width": "90%"
        },
        attrs: {
          "label": categoria.name,
          "value": categoria.id
        },
        model: {
          value: (_vm.classeSelecionada),
          callback: function($$v) {
            _vm.classeSelecionada = $$v
          },
          expression: "classeSelecionada"
        }
      })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(categoria.name))])], 2) : [_c('v-checkbox', {
        staticStyle: {
          "width": "90%"
        },
        attrs: {
          "label": categoria.name,
          "value": categoria.id
        },
        model: {
          value: (_vm.classeSelecionada),
          callback: function($$v) {
            _vm.classeSelecionada = $$v
          },
          expression: "classeSelecionada"
        }
      })]], 2)])], 1)]
    })], 2)]
  })], 2)], 2)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.a7f0b16c9b34889022b9.js